import { render, staticRenderFns } from "./case-deptor-addr.vue?vue&type=template&id=ccf463a2&"
import script from "./case-deptor-addr.vue?vue&type=script&lang=js&"
export * from "./case-deptor-addr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports